import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class DevHack extends Component {
  render() {
    return (
      <React.Fragment>
        <Grid container justify="center" style={{ paddingBottom: '1rem', paddingTop: '1rem' }}>
          <Grid item xs={10}>
            <Typography variant="h3" style={{ textAlign: 'center', color: '#5dc8ae', paddingBottom: '1rem', paddingTop: '1rem' }}>
              dev.hack()
            </Typography>
            <Grid container spacing={32}>
              <Grid item xs={12} md={6}>
                <div style={{ border: '1px solid #dae1e7', borderRadius: '.5rem' }}>
                  <img style={{ width: '100%', borderRadius: '0.5rem 0.5rem 0 0' }} src="./hackfools.jpg" alt="UCL Logo" />
                  <div style={{ padding: '1rem' }}>
                    <Typography variant="h4" style={{ fontWeight: '500' }}>
                      HackFools
                    </Typography>
                  </div>
                  <div style={{ borderBottom: '1px solid #dae1e7' }}></div>
                  <div style={{ padding: '1rem' }}>
                    <Typography variant="h6" style={{ fontWeight: '300', marginBottom: '0.5rem' }}>
                      <b style={{ fontWeight: '400' }}>HackDay</b> do UCL (8h de duração) com temática de 1º de Abril com 1ª realização em 2018.
                    </Typography>
                    <Typography variant="h6" style={{ fontWeight: '300', marginBottom: '0.5rem' }}>
                      Tem como público-alvo os <b style={{ fontWeight: '400' }}>ingressantes da USP</b> para que eles conheçam o formato de hackathons.
                    </Typography>
                    <Typography variant="h6" style={{ fontWeight: '300' }}>
                      Realizado com <b style={{ fontWeight: '400' }}>empresas parceiras</b> para que os participantes conheçam o ambiente de trabalho da área.
                    </Typography>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div style={{ border: '1px solid #dae1e7', borderRadius: '.5rem' }}>
                  <img style={{ width: '100%', borderRadius: '0.5rem 0.5rem 0 0' }} src="./hackathonusp.jpg" alt="UCL Logo" />
                  <div style={{ padding: '1rem' }}>
                    <Typography variant="h4" style={{ fontWeight: '500' }}>
                      HackathonUSP
                    </Typography>
                  </div>
                  <div style={{ borderBottom: '1px solid #dae1e7' }}></div>
                  <div style={{ padding: '1rem' }}>
                    <Typography variant="h6" style={{ fontWeight: '300', marginBottom: '0.5rem' }}>
                      <b style={{ fontWeight: '400' }}>Principal hackathon</b> do UCL (24h de duração), organizado <b style={{ fontWeight: '400' }}>desde 2016</b> com duas edições anuais.
                    </Typography>
                    <Typography variant="h6" style={{ fontWeight: '300', marginBottom: '0.5rem' }}>
                      Tem como público-alvo <b style={{ fontWeight: '400' }}>alunos da USP</b> com foco em criar um ambiente amigável para <b style={{ fontWeight: '400' }}>novos participantes</b>.
                    </Typography>
                    <Typography variant="h6" style={{ fontWeight: '300' }}>
                      Tem ganhado destaque na <a href="https://globoplay.globo.com/v/6800630/" rel="noopener noreferrer" target="_blank">imprensa externa</a> e <a href="https://jornal.usp.br/tag/hackathonusp/" rel="noopener noreferrer" target="_blank">universitária</a>, e já premiou uma <b style={{ fontWeight: '400' }}>viagem para o Vale do Silício</b>.
                    </Typography>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    )
  }
}

export default DevHack;